import { APP_INITIALIZER } from '@angular/core';
import { AuthBootstrapService } from '../../core/services/base-auth-boostrap.service';

export function authBootstrapInitializerFactory(authBootstrapService: AuthBootstrapService) {
  return () => authBootstrapService.initializeSession();
}

export const AUTH_BOOTSTRAP_INITIALIZER_PROVIDER = {
  provide: APP_INITIALIZER,
  useFactory: authBootstrapInitializerFactory,
  deps: [AuthBootstrapService],
  multi: true,
};
